import { render, staticRenderFns } from "./SamAccordion.vue?vue&type=template&id=4613f7db&scoped=true&shadow"
import script from "./SamAccordion.vue?vue&type=script&lang=js&shadow"
export * from "./SamAccordion.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamAccordion.vue?vue&type=style&index=0&id=4613f7db&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4613f7db",
  null
  ,true
)

export default component.exports